import { Box, Paper } from "@mui/material"
import { FormEvent } from "react";

interface ISearchboxWrapper {
    children: React.ReactNode;
}

export const SearchboxWrapper : React.FC<ISearchboxWrapper>= ( {
    children
} ) => {
    return (
        <Box 
            width="523px"
            position="relative"
        >        
                <Paper
                    component="form"
                    onSubmit={(e:FormEvent<HTMLFormElement>) => e.preventDefault()}
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: "523px", border: "1px solid #2D2D2D33", height: "36px" }}
                    elevation={0}
                >
                    { children }
                </Paper>
        </Box>
    )
}